import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.022 6.063c-.29-2.601 2.388-4.512 4.754-3.39l13.311 6.305c2.55 1.207 2.55 4.836 0 6.043L6.776 21.328c-2.366 1.121-5.043-.789-4.754-3.39l.535-4.824h9.047a1.115 1.115 0 1 0 0-2.229H2.558z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }